import React, { Component } from 'react';
import swal from "sweetalert";
import Aux from '../Aux/Aux';
import * as actionsCreators from "../../store/actions/index";
import { connect } from "react-redux";

const withErrorHandler = (WrappedComponent, axios) => {
    return class extends Component {
        state = {
            error: null
        }

        componentDidMount() {
            this.reqInterceptor = axios.interceptors.request.use(req => {
                this.setState({ error: null })
                return req;
            });

            this.resInterceptor = axios.interceptors.response.use(res => res, error => {
                this.setState({ error: error })
                if (error?.response?.status === 401) {
                const message = "Your session has expired. Please log in again.";
                    swal(
                    "Please Login Again",
                     "Your session has expired or your account was signed in on another device.",
                     "warning"
                    ).then(() => {
                    this.props.dispatch(
                        actionsCreators.logout()
                    );
                    })
                   
                }
                // alert(this.state.error ? this.state.error.message : null)
            });
        }

        componentWillUnmount() {
            axios.interceptors.request.eject(this.reqInterceptor);
            axios.interceptors.response.eject(this.resInterceptor);
        }

        errorConfirmedHandler = () => {
            this.setState({ error: null })
        }

        displayAlertHandler = () => {

        }


        render() {

            return (
                <Aux>
                    {/* <Modal 
                        show={this.state.error}
                        modalClosed={this.errorConfirmedHandler}>
                        {this.state.error? this.state.error.message : null}
                    </Modal> */}

                    {/* <Modal
                    open={true}
                    onClose={this.errorConfirmedHandler}
                    aria-labelledby="simple-modal-title"
                    aria-describedby="simple-modal-description"
                    >
                        {this.state.error? this.state.error.message : null}
                    </Modal> */}

                    <WrappedComponent {...this.props} />
                </Aux>
            )
        }
    }
      return connect(
    null,
    null,
  )(withErrorHandler);
}

export default withErrorHandler;